(function () {
    'use strict';

    angular
        .module('riskSelfAssessmentAssessControllers', ['actionPlanModule',
                                                        'governanceProcessModule',
                                                        'riskModule',
                                                        'services.historyCtxt']);
})();
